import network from './index';

export const getOwner = () => {
  return network.get('/api/hubspot/owner');
};

export const getPipeline = () => {
  return network.get('/api/hubspot/pipeline');
};